<script>
import { push } from "svelte-spa-router";
import { onMount } from 'svelte';
import { get } from 'svelte/store';
import { info_client, client } from './stores';

  const getDefaultRoute = () => {
    const userInfo = get(info_client);
    const clientInfo = get(client);
    const isUserFromUae = userInfo.flow?.is_uae || clientInfo.flow?.settings?.for_uae;

    if (IS_SHOW_FEED && userInfo.has_feed_publications) {
      return '/listnews/feed_groops=physical_transformation';
    }

    if (IS_SHOW_WIKI && userInfo.has_wiki_publications) {
      return '/wiki/category';
    }

    if (!userInfo.flow?.is_green && !isUserFromUae && userInfo.has_community_publications) {
      return '/community/';
    }

    return '/listnews/feed_groops=physical_transformation';
  };

  onMount(() => {
    push(getDefaultRoute());
  });
</script>
